import { useMemo } from "react";
import { Dropdown, Badge, Typography, Button } from "antd";
import {
  DashboardOutlined,
  TeamOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  CalendarOutlined,
  CommentOutlined,
  IdcardOutlined,
  ApartmentOutlined,
  SolutionOutlined,
  TagOutlined,
  UsergroupAddOutlined,
  DeploymentUnitOutlined,
  FileTextOutlined,
  MenuOutlined,
  PictureOutlined,
  TableOutlined,
  SignatureOutlined,
  CheckSquareOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routes";
import { useSelector } from "react-redux";
import { selectNewMessageCount } from "../../../store/chats/selectors";

const XsSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const newMessageCount = useSelector(selectNewMessageCount);

  const menuItems = useMemo(
    () => [
      // --- Dashboard ---
      {
        key: ROUTES.DASHBOARD,
        icon: <DashboardOutlined />,
        label: "Dashboard",
        onClick: () => navigate(ROUTES.DASHBOARD),
      },

      { type: "divider" },
      {
        type: "group",
        label: (
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>
            COMMUNICATION
          </Typography.Text>
        ),
        children: [
          {
            key: ROUTES.CHATS,
            icon: <CommentOutlined />,
            label: (
              <span>
                Conversations
                {newMessageCount ? (
                  <Badge count={newMessageCount} style={{ marginLeft: 8 }} />
                ) : null}
              </span>
            ),
            onClick: () => navigate(ROUTES.CHATS),
          },
          {
            key: ROUTES.POSTER,
            icon: <PictureOutlined />,
            label: "Poster",
            onClick: () => navigate(ROUTES.POSTER),
          },
          {
            key: ROUTES.OPENSIGN,
            icon: <SignatureOutlined />,
            label: "Open Sign",
            onClick: () => navigate(ROUTES.OPENSIGN),
          },
          {
            key: ROUTES.TASKS,
            icon: <CheckSquareOutlined />,
            label: "Task Management",
            onClick: () => navigate(ROUTES.TASKS),
          },
          {
            key: ROUTES.SPREADSHEET,
            icon: <TableOutlined />,
            label: "Spreadsheet",
            onClick: () => navigate(ROUTES.SPREADSHEET),
          },
          {
            key: ROUTES.CUSTOMERS,
            icon: <IdcardOutlined />,
            label: "Customers",
            onClick: () => navigate(ROUTES.CUSTOMERS),
          },
          {
            key: ROUTES.BRANCH,
            icon: <ApartmentOutlined />,
            label: "Branches",
            onClick: () => navigate(ROUTES.BRANCH),
          },
          {
            key: ROUTES.ADVISOR,
            icon: <SolutionOutlined />,
            label: "Advisors",
            onClick: () => navigate(ROUTES.ADVISOR),
          },
          {
            key: ROUTES.TOPICS,
            icon: <TagOutlined />,
            label: "Topics",
            onClick: () => navigate(ROUTES.TOPICS),
          },
        ],
      },

      { type: "divider" },
      {
        type: "group",
        label: (
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>
            MANAGEMENT
          </Typography.Text>
        ),
        children: [
          {
            key: "TEAM_GROUP",
            icon: <TeamOutlined />,
            label: "Team",
            children: [
              {
                key: ROUTES.USERS,
                icon: <UsergroupAddOutlined />,
                label: "Users",
                onClick: () => navigate(ROUTES.USERS),
              },
              {
                key: ROUTES.TEAM,
                icon: <DeploymentUnitOutlined />,
                label: "Teams",
                onClick: () => navigate(ROUTES.TEAM),
              },
              {
                key: ROUTES.CALENDAR,
                icon: <CalendarOutlined />,
                label: "Calendar",
                onClick: () => navigate(ROUTES.CALENDAR),
              },
            ],
          },
          {
            key: ROUTES.DOCUMENTATION,
            icon: <FileTextOutlined />,
            label: "Documentation",
            onClick: () => navigate(ROUTES.DOCUMENTATION),
          },
        ],
      },

      { type: "divider" },

      // --- Bottom items ---
      {
        key: ROUTES.BUSINESS,
        icon: <SettingOutlined />,
        label: "Settings",
        onClick: () => navigate(ROUTES.BUSINESS),
      },
      {
        key: ROUTES.HELP,
        icon: <QuestionCircleOutlined />,
        label: "Help & Support",
        onClick: () => navigate(ROUTES.HELP),
      },
    ],
    [newMessageCount, navigate],
  );

  return (
    <Dropdown
      menu={{
        //@ts-ignore
        items: menuItems,
        selectedKeys: [location.pathname],
      }}
      trigger={["click"]}
      placement="bottomLeft"
      styles={{
        root: { minWidth: 220 },
      }}
    >
      <Button
        type="text"
        style={{
          marginLeft: "10px",
          color: "white",
        }}
        icon={<MenuOutlined style={{ fontSize: "20px" }} />}
      />
    </Dropdown>
  );
};

export default XsSidebar;
